// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"418":"64c7b2af","668":"55cc4d52"}[chunkId] + ".js";
};